import { ref } from 'vue';

import { AbstractQueryParams, QueryString } from 'SharedDir/common/composables/useQueryString';

export type Filters = {
  name: string | null;
  fromDate: string | null;
  toDate: string | null;
};

export function usePublicUsefulLinksFilters() {
  const defaultFilterParams = (): Filters => ({ name: null, fromDate: null, toDate: null });

  const filterParams = ref(defaultFilterParams());

  const sanitizeQueryFilterParams = (): AbstractQueryParams => ({
    name: QueryString,
    fromDate: QueryString,
    toDate: QueryString,
  });

  return {
    filterParams,
    defaultFilterParams,
    sanitizeQueryFilterParams,
  };
}
